import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  TextField,
  Button,
} from "@material-ui/core";
import useCheckoutClassicStyles from "./checkoutClassicStyles";

export default function OrderSummary({
  showCoupon,
  lines,
  couponInput,
  onCouponChange,
  onApplyCoupon,
  onRemoveCoupon,
  couponLoading,
  couponError,
  subtotalLabel,
  discountLabel,
  appliedCoupon,
  gstPct,
  gstLabel,
  gstAmountLabel,
  totalLabel,
  paying,
  canPay,
  onPay,
  payError,
  ctaLabel,
  hideCta,
}) {
  const classes = useCheckoutClassicStyles();
  return (
    <Card className={classes.summaryCard} elevation={0}>
      <CardContent style={{ padding: "16px" }}>
        <Typography variant="h6" className={classes.summaryTitle}>
          Order Summary
        </Typography>

      {lines.map((l, i) => (
        <Box key={i} className={classes.summaryItem}>
          <Typography className={classes.summaryItemName}>
            {l.name}
            {l.oneTime ? <span className={classes.oneTimeTag}> (one-time)</span> : null}
          </Typography>
          <Typography className={classes.summaryItemPrice}>
            {l.originalLabel ? (
              <span className={classes.originalPrice}>{l.originalLabel}</span>
            ) : null}
            {l.priceLabel}
          </Typography>
        </Box>
      ))}

      <hr className={classes.hr} />

      <Box className={classes.subtotalRow}>
        <span>Subtotal</span>
        <span>{subtotalLabel}</span>
      </Box>
      {discountLabel && (
        <Box className={classes.subtotalRow} style={{ marginTop: 4 }}>
          <span>Discount{appliedCoupon ? ` (${appliedCoupon})` : ""}</span>
          <span>-{discountLabel}</span>
        </Box>
      )}
      {gstPct > 0 && (
        <Box className={classes.subtotalRow} style={{ marginTop: 4 }}>
          <span>
            {gstLabel} ({gstPct}%)
          </span>
          <span>{gstAmountLabel}</span>
        </Box>
      )}

      {/* Coupon block — only when the page has an active coupon (server-resolved
          mode "input"). Placed after Subtotal/GST and before Total, matching the
          reference summary. */}
      {showCoupon && (
        appliedCoupon ? (
          <div className={classes.couponApplied}>
            <span className={classes.couponAppliedCode}>✓ {appliedCoupon}</span>
            <Button
              className={classes.couponRemoveButton}
              size="small"
              onClick={onRemoveCoupon}
            >
              Remove
            </Button>
          </div>
        ) : (
          <>
            <Typography variant="subtitle2" className={classes.couponLabel}>
              Got a coupon code?
            </Typography>
            <div className={classes.couponInput}>
              <TextField
                className={classes.couponTextField}
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Enter Code"
                value={couponInput}
                onChange={(e) => onCouponChange(e.target.value)}
              />
              <Button
                className={classes.couponButton}
                size="small"
                onClick={onApplyCoupon}
                disabled={couponLoading || !couponInput.trim()}
              >
                {couponLoading ? "Applying…" : "Apply"}
              </Button>
            </div>
            {couponError && (
              <div className={classes.fieldError}>{couponError}</div>
            )}
          </>
        )
      )}

      <Box className={classes.totalRow}>
        <Typography className={classes.totalLabel}>
          Total{gstPct > 0 ? " (incl. GST)" : ""}
        </Typography>
        <Typography className={classes.totalAmount}>{totalLabel}</Typography>
      </Box>

      {/* Replaced by MobileStickyBar on mobile. */}
      <Button
        className={
          hideCta
            ? `${classes.proceedButton} ${classes.hideOnMobile}`
            : classes.proceedButton
        }
        fullWidth
        variant="contained"
        onClick={onPay}
        disabled={paying || !canPay}
        style={{ marginTop: 12 }}
      >
        {paying ? "Processing…" : ctaLabel}
      </Button>
        {payError && (
          <div className={classes.fieldError} data-error-anchor>
            {payError}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
